import { render, staticRenderFns } from "./farm_list.vue?vue&type=template&id=48582696&scoped=true&"
import script from "./farm_list.vue?vue&type=script&lang=js&"
export * from "./farm_list.vue?vue&type=script&lang=js&"
import style0 from "./farm_list.vue?vue&type=style&index=0&id=48582696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48582696",
  null
  
)

export default component.exports